// import React, { useState } from "react";

// const EquipmentRefurbishment = () => {
//   const [activeSlide, setActiveSlide] = useState(0);

//   const slides = [
//     {
//       title: "Full Spectrum Equipment Support",
//       image: "./assets/img/bg/mans.png",
//       content: [
//         {
//           heading: "Installation & Maintenance",
//           items: [
//             "Full spectrum support across all Process Modules",
//             "Installation, Upgrades, Refurbishment, Repairs",
//             "Qualifications and Maintenance services",
//             "Annual Maintenance Contracts [AMC]"
//           ]
//         },
//         {
//           heading: "Equipment Expertise",
//           items: [
//             "Retrofit and qualification of legacy and refurbished equipment",
//             "Real-time monitoring infrastructure for process control",
//             "Ongoing improvements in Preventive Maintenance [PM] strategies"
//           ]
//         }
//       ]
//     },
//     {
//       title: "Module Expertise – Equipment & Technology",
//       image: "./assets/img/bg/hc.jpg",
//       content: [
//         {
//           heading: "Diffusion / WET",
//           items: [
//             "Wet benches: DNS, Kaijo, SES",
//             "Backside cleaning: SEZ, Nexgen"
//           ]
//         },
//         {
//           heading: "Chemical Mechanical Planarization",
//           items: ["DNS", "AMAT"]
//         },
//         {
//           heading: "Lithography",
//           items: ["ASML, Nikon, TEL, Suss"]
//         },
//         {
//           heading: "Thin Film Deposition - CVD & PEALD",
//           items: ["AMAT, ASM, Novellus (LAM), Telemark"]
//         }
//       ]
//     },
//     {
//       title: "Advanced Process Equipment",
//       image: "./assets/img/bg/mans.png",
//       content: [
//         {
//           heading: "Ion Implant",
//           items: ["Axcelis - Advanced control and integration"]
//         },
//         {
//           heading: "Etch",
//           items: ["Mattson, LAM - Plasma-based systems"]
//         },
//         {
//           heading: "Metrology & Inspection",
//           items: [
//             "KLA Tools - Critical Dimension metrology",
//             "Hitachi, Zeiss, Quantox, Semilab"
//           ]
//         },
//         {
//           heading: "Other Services",
//           items: [
//             "Sort and Merge: Brooks",
//             "Cleanroom design, construction certification"
//           ]
//         }
//       ]
//     },
//     {
//       title: "Strategic Enhancements & Global Partners",
//       image: "./assets/img/bg/hc.jpg",
//       content: [
//         {
//           heading: "Strategic Enhancements",
//           items: [
//             "200+ years of collective experience",
//             "Strong Supplier Management and Program Governance",
//             "Refurbished equipment integration for cost-efficiency",
//             "Real-time monitoring systems deployed across modules",
//             "Introduction of alternative sources: Chemicals, Slurries"
//           ]
//         },
//         {
//           heading: "Global Partner Network",
//           items: [
//             "Partners primarily based in Taiwan, Singapore",
//             "Proven expertise at TSMC, UMC, GF",
//             "Wafer Fab experienced manpower support"
//           ]
//         }
//       ]
//     }
//   ];

//   const nextSlide = () => {
//     setActiveSlide((prev) => (prev + 1) % slides.length);
//   };

//   const prevSlide = () => {
//     setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
//   };

//   return (
//     <div style={{ fontFamily: "Arial, sans-serif" }}>
//       {/* Hero Section */}
//       {/* <section style={{ position: "relative", height: "500px", overflow: "hidden" }}>
//         <img
//           src="assets/img/service/mw7.png"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             position: "absolute",
//             top: 0,
//             left: 0
//           }}
//           alt="Hero Background"
//         />
//         <div
//           style={{
//             position: "relative",
//             zIndex: 2,
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             background: "rgba(0, 0, 0, 0.5)",
//             color: "white",
//             textAlign: "center",
//             padding: "20px"
//           }}
//         >
//           <div>
//             <p style={{ fontSize: "18px", letterSpacing: "3px", marginBottom: "10px" }}>
//               Equipment Refurbishment
//             </p>
//             <p
//               style={{
//                 backgroundColor: "rgb(232, 119, 34)",
//                 color: "white",
//                 padding: "8px 15px",
//                 fontWeight: "bold",
//                 display: "inline-block",
//                 borderRadius: "5px",
//                 marginBottom: "20px"
//               }}
//             >
//               SEMANTIC Skills Junction
//             </p>
//             <h1 style={{ fontSize: "45px", margin: "20px 0", lineHeight: 1.2 }}>
//               Equipment Support & Technology Excellence
//             </h1>
//             <p style={{ fontSize: "16px", marginTop: "15px" }}>
//               <a href="/" style={{ color: "white", textDecoration: "none" }}>Home</a> / Equipment Refurbishment
//             </p>
//           </div>
//           <a
//             href="tel:+917619617023"
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "20px",
//               color: "white",
//               textDecoration: "none",
//               fontSize: "18px",
//               fontWeight: "bold"
//             }}
//           >
//             (+91) 7619617023
//           </a>
//         </div>
//       </section> */}
//       <section className="common-page-hero">
//         <img
//           src="assets/img/service/mw7.png"
//           className="common-hero-bg ak-bg"
//           alt="..."
//         />
//         <div className="common-hero-content">
//           <div className="common-hero-info">
//             <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
//               <p
//                 className="ak-section-subtitle animation-title"
//                 style={{ perspective: "400px" }}
//               >
//                 <div
//                   className="split-line"
//                   style={{
//                     display: "block",
//                     textAlign: "center",
//                     position: "relative",
//                   }}
//                 >
//                   {"Courses".split("").map((char, index) => (
//                     <div
//                       key={index}
//                       style={{
//                         position: "relative",
//                         display: "inline-block",
//                         transform: "translate(0px, 0px)",
//                         opacity: 1,
//                       }}
//                     >
//                       {char}
//                     </div>
//                   ))}
//                 </div>
//               </p>
//               <br />
//               <p
//                 className="mini-title1"
//                 style={{
//                   backgroundColor: "rgb(232, 119, 34)",
//                   color: "white",
//                   padding: "5px 10px",
//                   fontWeight: "bold",
//                   display: "inline-block",
//                   borderRadius: "5px",
//                 }}
//               >
//                 SEMANTIC Skills Junction
//               </p>
//               <br />
//               <h2
//                 className="ak-section-title animation-title"
//                 style={{ fontSize: "45px", perspective: "400px" }}
//               >
//                 <div
//                   className="split-line"
//                   style={{
//                     display: "block",
//                     textAlign: "center",
//                     position: "relative",
//                   }}
//                 >
//                   {"SEMANTIC Skills Junction: Bridging"
//                     .split(" ")
//                     .map((word, idx1) => (
//                       <span
//                         key={idx1}
//                         style={{
//                           position: "relative",
//                           display: "inline-block",
//                         }}
//                       >
//                         {word.split("").map((char, idx2) => (
//                           <div
//                             key={idx2}
//                             style={{
//                               position: "relative",
//                               display: "inline-block",
//                               transform: "translate(0px, 0px)",
//                               opacity: 1,
//                             }}
//                           >
//                             {char}
//                           </div>
//                         ))}
//                         &nbsp;
//                       </span>
//                     ))}
//                 </div>
//                 <div
//                   className="split-line"
//                   style={{
//                     display: "block",
//                     textAlign: "center",
//                     position: "relative",
//                   }}
//                 >
//                   {"Talent and Technology".split(" ").map((word, idx1) => (
//                     <span
//                       key={idx1}
//                       style={{ position: "relative", display: "inline-block" }}
//                     >
//                       {word.split("").map((char, idx2) => (
//                         <div
//                           key={idx2}
//                           style={{
//                             position: "relative",
//                             display: "inline-block",
//                             transform: "translate(0px, 0px)",
//                             opacity: 1,
//                           }}
//                         >
//                           {char}
//                         </div>
//                       ))}
//                       &nbsp;
//                     </span>
//                   ))}
//                 </div>
//               </h2>
//             </div>
//             <p className="back-btn">
//               <a href="/">Home</a> / Course
//             </p>
//           </div>
//           <a href="tel:+917619617023" className="phone-number">
//             (+91) 7619617023
//           </a>
//         </div>
//       </section>
//       {/* Strategic Points Section */}
//       <div style={{ padding: "2rem", maxWidth: "1200px", margin: "20px auto" }}>
//         <div
//           style={{
//             background: "linear-gradient(to bottom right, #fff5f5, #fff0ea)",
//             borderRadius: "8px",
//             padding: "2rem",
//             boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
//           }}
//         >
//           <h2
//             style={{
//               color: "#c53030",
//               fontSize: "38px",
//               fontWeight: "bold",
//               marginBottom: "1.5rem"
//             }}
//           >
//             SCOPE OF INDUSTRY CONSULTANCY SERVICES
//           </h2>
//           <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Installation, Upgrades & Refurbishment
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Full spectrum support across all Process Modules, Repairs, Qualifications, Maintenance
//                 </span>
//               </p>
//             </div>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Equipment Retrofit & Qualification
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Legacy and refurbished equipment with real-time monitoring infrastructure
//                 </span>
//               </p>
//             </div>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Quality Management System [QMS]
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Setup, Implementation, Certification, Maintenance with robust program governance
//                 </span>
//               </p>
//             </div>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Preventive Maintenance & AMC
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Ongoing improvements in PM strategies, Annual Maintenance Contracts, Process Centering
//                 </span>
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content with Description */}
//       <section style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
//         <div style={{ marginTop: "15px", fontSize: "20px", lineHeight: 1.6, color: "#333" }}>
//           We provide comprehensive equipment support services leveraging <strong>200+ years of collective experience</strong> across 
//           semiconductor manufacturing. Our services include upgrade, replacement, refurbishment of legacy and new OEM tools with 
//           strong supplier management and program governance. We deploy real-time monitoring systems, introduce alternative sources 
//           for chemicals and slurries, and execute cross-functional projects focused on Quality, Cost, and Productivity.
//         </div>

//         {/* Slider Section */}
//         <div style={{ marginTop: "40px" }}>
//           <div style={{ position: "relative" }}>
//             <div style={{ overflow: "hidden" }}>
//               <div style={{ display: "flex", transition: "transform 0.3s ease" }}>
//                 <div style={{ minWidth: "100%", display: "flex", gap: "20px", padding: "20px 0" }}>
//                   <div
//                     style={{
//                       flex: "0 0 40%",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center"
//                     }}
//                   >
//                     <img
//                       src={slides[activeSlide].image}
//                       style={{
//                         maxWidth: "100%",
//                         height: "auto",
//                         borderRadius: "8px",
//                         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
//                       }}
//                       alt="Slide"
//                     />
//                   </div>
//                   <div style={{ flex: "0 0 60%", padding: "20px" }}>
//                     <h3 style={{ fontSize: "28px", color: "#c53030", marginBottom: "20px" }}>
//                       {slides[activeSlide].title}
//                     </h3>
//                     {slides[activeSlide].content.map((section, idx) => (
//                       <div key={idx} style={{ marginBottom: "20px" }}>
//                         <h4
//                           style={{
//                             marginTop: "10px",
//                             marginLeft: "20px",
//                             lineHeight: 1.5,
//                             fontSize: "20px",
//                             color: "#2d3748",
//                             fontWeight: "600"
//                           }}
//                         >
//                           {section.heading}
//                         </h4>
//                         <ul style={{ marginLeft: "30px", lineHeight: 1.8 }}>
//                           {section.items.map((item, i) => (
//                             <li key={i} style={{ fontSize: "16px", color: "#4a5568" }}>
//                               {item}
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Navigation Buttons */}
//             <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
//               <button
//                 onClick={prevSlide}
//                 style={{
//                   padding: "10px 15px",
//                   background: "#fff",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center"
//                 }}
//                 aria-label="Previous slide"
//               >
//                 <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
//                   <path
//                     d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
//                     stroke="#030917"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//               <button
//                 onClick={nextSlide}
//                 style={{
//                   padding: "10px 15px",
//                   background: "#fff",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center"
//                 }}
//                 aria-label="Next slide"
//               >
//                 <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
//                   <path
//                     d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
//                     stroke="#030917"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//             </div>

//             {/* Slide Indicators */}
//             <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "15px" }}>
//               {slides.map((_, idx) => (
//                 <div
//                   key={idx}
//                   onClick={() => setActiveSlide(idx)}
//                   style={{
//                     width: "12px",
//                     height: "12px",
//                     borderRadius: "50%",
//                     background: activeSlide === idx ? "#c53030" : "#ccc",
//                     cursor: "pointer",
//                     transition: "background 0.3s"
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Proven Capability Section */}
//       <section style={{ background: "linear-gradient(to bottom right, #fff5f5, #fff0ea)", padding: "40px 20px", marginTop: "40px" }}>
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           <h2 style={{ fontSize: "36px", color: "#c53030", textAlign: "center", marginBottom: "30px" }}>
//             Proven Capability Through Global Expertise
//           </h2>
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
//             {[
//               {
//                 title: "Industry-Seasoned Core Team",
//                 points: [
//                   "Semiconductor professionals with decades of hands-on experience",
//                   "Track record in executing refurb, retrofit, and installation",
//                   "Expertise in critical wafer processing tools"
//                 ]
//               },
//               {
//                 title: "Elite Global Partner Network",
//                 points: [
//                   "Accomplished specialists in equipment refurbishment",
//                   "Executed projects in leading Fabs like TSMC, UMC",
//                   "Diverse regional strengths to optimize sourcing"
//                 ]
//               },
//               {
//                 title: "Outcome-Driven Delivery",
//                 points: [
//                   "SOPs, Process maps, Real-time project dashboards",
//                   "Transparent execution w.r.t. milestones",
//                   "Rigorous multi-point inspection and certification framework"
//                 ]
//               },
//               {
//                 title: "Scalable, Agile Supply Chain",
//                 points: [
//                   "Modular network adapts rapidly to dynamic timelines",
//                   "Flexible procurement and technical scope changes",
//                   "Risk mitigation through redundancy"
//                 ]
//               },
//               {
//                 title: "Risk Mitigation Through Redundancy",
//                 points: [
//                   "Multiple vetted partners mean robust fallback options",
//                   "Avoids single-point failures",
//                   "Ensures uninterrupted delivery"
//                 ]
//               },
//               {
//                 title: "Value Beyond Equipment",
//                 points: [
//                   "Turnkey support and Documentation",
//                   "Tools AMC, PM support",
//                   "Training to Fab personnel and Trained Manpower support"
//                 ]
//               }
//             ].map((card, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: "white",
//                   padding: "25px",
//                   borderRadius: "8px",
//                   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
//                 }}
//               >
//                 <h3 style={{ fontSize: "22px", color: "#c53030", marginBottom: "15px", fontWeight: "bold" }}>
//                   {card.title}
//                 </h3>
//                 <ul style={{ listStyle: "none", padding: 0 }}>
//                   {card.points.map((point, i) => (
//                     <li
//                       key={i}
//                       style={{
//                         fontSize: "16px",
//                         color: "#4a5568",
//                         marginBottom: "10px",
//                         paddingLeft: "20px",
//                         position: "relative",
//                         lineHeight: 1.6
//                       }}
//                     >
//                       <span
//                         style={{
//                           position: "absolute",
//                           left: 0,
//                           color: "#c53030",
//                           fontWeight: "bold"
//                         }}
//                       >
//                         •
//                       </span>
//                       {point}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Module Support Section */}
//       <section style={{ padding: "40px 20px", maxWidth: "1200px", margin: "0 auto" }}>
//         <h2 style={{ fontSize: "36px", color: "#c53030", textAlign: "center", marginBottom: "30px" }}>
//           Module Support Through Trusted Global Partners
//         </h2>
//         <div style={{ textAlign: "center", fontSize: "18px", marginBottom: "30px", color: "#4a5568" }}>
//           <p>Partners are primarily based in <strong>Taiwan, Singapore, Korea</strong></p>
//           <p style={{ marginTop: "10px" }}>
//             Several decades of experience with proven expertise at <strong>TSMC, UMC, GF</strong>
//           </p>
//           <p style={{ marginTop: "10px" }}>Equipment Retrofits, Relocation, Hookups, Maintenance</p>
//         </div>

//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: "20px",
//             marginTop: "30px"
//           }}
//         >
//           {[
//             { name: "DIFFUSION", desc: "Deep capability across thermal based systems" },
//             { name: "RTP", desc: "Rapid Thermal Processing" },
//             { name: "ETCH", desc: "Plasma-based systems" },
//             { name: "IMPLANT", desc: "Advanced control and integration" },
//             { name: "CD-SEM", desc: "Critical Dimension metrology & inspection" },
//             { name: "KLA TOOLS", desc: "Advanced inspection systems" },
//             { name: "PVD", desc: "Scalable solutions for metal and dielectric deposition" },
//             { name: "CVD", desc: "Chemical Vapor Deposition systems" }
//           ].map((module, idx) => (
//             <div
//               key={idx}
//               style={{
//                 background: "linear-gradient(135deg, #c53030, #e87722)",
//                 color: "white",
//                 padding: "30px 20px",
//                 borderRadius: "8px",
//                 textAlign: "center",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 transition: "transform 0.3s",
//                 cursor: "pointer"
//               }}
//               onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
//               onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
//             >
//               <h3 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "10px" }}>
//                 {module.name}
//               </h3>
//               <p style={{ fontSize: "14px", opacity: 0.9 }}>{module.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Thank You Section */}
//       {/* <section
//         style={{
//           background: "linear-gradient(to right, #c53030, #e87722)",
//           color: "white",
//           padding: "60px 20px",
//           textAlign: "center"
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           <h2 style={{ fontSize: "42px", marginBottom: "20px", fontWeight: "bold" }}>
//             Let us work together to do our part for the India Semiconductor success story
//           </h2>
//           <p style={{ fontSize: "28px", marginTop: "30px", fontWeight: "600" }}>
//             Our Time is NOW!
//           </p>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
//               gap: "15px",
//               marginTop: "40px",
//               fontSize: "18px"
//             }}
//           >
//             {[
//               "Thank You",
//               "ধন্যবাদ",
//               "આભાર",
//               "धन्यवाद",
//               "ಧನ್ಯವಾದಗಳು",
//               "നന്ദി",
//               "ଧନ୍ୟବାଦ",
//               "ਧੰਨਵਾਦ",
//               "நன்றி",
//               "ధన్యవాదాలు",
//               "Dank Schön",
//               "Merci",
//               "Gracias"
//             ].map((text, idx) => (
//               <div key={idx} style={{ padding: "10px", opacity: 0.9 }}>
//                 {text}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section> */}

//       {/* Footer Note */}
//       {/* <div
//         style={{
//           textAlign: "center",
//           padding: "20px",
//           fontSize: "14px",
//           color: "#666",
//           background: "#f9f9f9"
//         }}
//       >
//         <p>
//           <strong>Note:</strong> Possible scaling with faster onboarding upon confirmation
//         </p>
//       </div> */}
//     </div>
//   );
// };

// export default EquipmentRefurbishment;


// import React, { useState } from "react";

// const EquipmentRefurbishment = () => {
//   const [activeSlide, setActiveSlide] = useState(0);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   // Handle window resize
//   React.useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const slides = [
//     {
//       title: "Full Spectrum Equipment Support",
//       image: "./assets/img/bg/mans.png",
//       content: [
//         {
//           heading: "Installation & Maintenance",
//           items: [
//             "Full spectrum support across all Process Modules",
//             "Installation, Upgrades, Refurbishment, Repairs",
//             "Qualifications and Maintenance services",
//             "Annual Maintenance Contracts [AMC]"
//           ]
//         },
//         {
//           heading: "Equipment Expertise",
//           items: [
//             "Retrofit and qualification of legacy and refurbished equipment",
//             "Real-time monitoring infrastructure for process control",
//             "Ongoing improvements in Preventive Maintenance [PM] strategies"
//           ]
//         }
//       ]
//     },
//     {
//       title: "Module Expertise – Equipment & Technology",
//       image: "./assets/img/bg/hc.jpg",
//       content: [
//         {
//           heading: "Diffusion / WET",
//           items: [
//             "Wet benches: DNS, Kaijo, SES",
//             "Backside cleaning: SEZ, Nexgen"
//           ]
//         },
//         {
//           heading: "Chemical Mechanical Planarization",
//           items: ["DNS", "AMAT"]
//         },
//         {
//           heading: "Lithography",
//           items: ["ASML, Nikon, TEL, Suss"]
//         },
//         {
//           heading: "Thin Film Deposition - CVD & PEALD",
//           items: ["AMAT, ASM, Novellus (LAM), Telemark"]
//         }
//       ]
//     },
//     {
//       title: "Advanced Process Equipment",
//       image: "./assets/img/bg/mans.png",
//       content: [
//         {
//           heading: "Ion Implant",
//           items: ["Axcelis - Advanced control and integration"]
//         },
//         {
//           heading: "Etch",
//           items: ["Mattson, LAM - Plasma-based systems"]
//         },
//         {
//           heading: "Metrology & Inspection",
//           items: [
//             "KLA Tools - Critical Dimension metrology",
//             "Hitachi, Zeiss, Quantox, Semilab"
//           ]
//         },
//         {
//           heading: "Other Services",
//           items: [
//             "Sort and Merge: Brooks",
//             "Cleanroom design, construction certification"
//           ]
//         }
//       ]
//     },
//     {
//       title: "Strategic Enhancements & Global Partners",
//       image: "./assets/img/bg/hc.jpg",
//       content: [
//         {
//           heading: "Strategic Enhancements",
//           items: [
//             "200+ years of collective experience",
//             "Strong Supplier Management and Program Governance",
//             "Refurbished equipment integration for cost-efficiency",
//             "Real-time monitoring systems deployed across modules",
//             "Introduction of alternative sources: Chemicals, Slurries"
//           ]
//         },
//         {
//           heading: "Global Partner Network",
//           items: [
//             "Partners primarily based in Taiwan, Singapore",
//             "Proven expertise at TSMC, UMC, GF",
//             "Wafer Fab experienced manpower support"
//           ]
//         }
//       ]
//     }
//   ];

//   const nextSlide = () => {
//     setActiveSlide((prev) => (prev + 1) % slides.length);
//   };

//   const prevSlide = () => {
//     setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
//   };

//   return (
//     <div style={{ fontFamily: "Arial, sans-serif" }}>
//       {/* Hero Section */}
//       <section style={{ position: "relative", height: "500px", overflow: "hidden" }}>
//         <img
//           src="assets/img/service/mw7.png"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             position: "absolute",
//             top: 0,
//             left: 0
//           }}
//           alt="Hero Background"
//         />
//         <div
//           style={{
//             position: "relative",
//             zIndex: 2,
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             background: "rgba(0, 0, 0, 0.5)",
//             color: "white",
//             textAlign: "center",
//             padding: "20px"
//           }}
//         >
//           <div>
//             <p style={{ fontSize: "18px", letterSpacing: "3px", marginBottom: "10px" }}>
//               Equipment Refurbishment
//             </p>
//             <p
//               style={{
//                 backgroundColor: "rgb(232, 119, 34)",
//                 color: "white",
//                 padding: "8px 15px",
//                 fontWeight: "bold",
//                 display: "inline-block",
//                 borderRadius: "5px",
//                 marginBottom: "20px"
//               }}
//             >
//               SEMANTIC Skills Junction
//             </p>
//             <h1 style={{ fontSize: "45px", margin: "20px 0", lineHeight: 1.2 }}>
//               Equipment Support & Technology Excellence
//             </h1>
//             <p style={{ fontSize: "16px", marginTop: "15px" }}>
//               <a href="/" style={{ color: "white", textDecoration: "none" }}>Home</a> / Equipment Refurbishment
//             </p>
//           </div>
//           <a
//             href="tel:+917619617023"
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "20px",
//               color: "white",
//               textDecoration: "none",
//               fontSize: "18px",
//               fontWeight: "bold"
//             }}
//           >
//             (+91) 7619617023
//           </a>
//         </div>
//       </section>

//       {/* Strategic Points Section */}
//       <div style={{ padding: "2rem", maxWidth: "1200px", margin: "20px auto" }}>
//         <div
//           style={{
//             background: "linear-gradient(to bottom right, #fff5f5, #fff0ea)",
//             borderRadius: "8px",
//             padding: "2rem",
//             boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
//           }}
//         >
//           <h2
//             style={{
//               color: "#c53030",
//               fontSize: "38px",
//               fontWeight: "bold",
//               marginBottom: "1.5rem"
//             }}
//           >
//             SCOPE OF INDUSTRY CONSULTANCY SERVICES
//           </h2>
//           <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Installation, Upgrades & Refurbishment
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Full spectrum support across all Process Modules, Repairs, Qualifications, Maintenance
//                 </span>
//               </p>
//             </div>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Equipment Retrofit & Qualification
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Legacy and refurbished equipment with real-time monitoring infrastructure
//                 </span>
//               </p>
//             </div>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Quality Management System [QMS]
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Setup, Implementation, Certification, Maintenance with robust program governance
//                 </span>
//               </p>
//             </div>
//             <div>
//               <p style={{ marginBottom: "10px" }}>
//                 <span
//                   style={{
//                     color: "rgb(179, 0, 0)",
//                     fontWeight: "bold",
//                     fontSize: "20px"
//                   }}
//                 >
//                   ➤ Preventive Maintenance & AMC
//                 </span>{" "}
//                 –{" "}
//                 <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
//                   Ongoing improvements in PM strategies, Annual Maintenance Contracts, Process Centering
//                 </span>
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content with Description */}
//       <section style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
//         <div style={{ marginTop: "15px", fontSize: "20px", lineHeight: 1.6, color: "#333" }}>
//           We provide comprehensive equipment support services leveraging <strong>200+ years of collective experience</strong> across 
//           semiconductor manufacturing. Our services include upgrade, replacement, refurbishment of legacy and new OEM tools with 
//           strong supplier management and program governance. We deploy real-time monitoring systems, introduce alternative sources 
//           for chemicals and slurries, and execute cross-functional projects focused on Quality, Cost, and Productivity.
//         </div>

//         {/* Slider Section */}
//         <div style={{ marginTop: "40px" }}>
//           <div style={{ position: "relative" }}>
//             <div style={{ overflow: "hidden" }}>
//               <div style={{ display: "flex", transition: "transform 0.3s ease" }}>
//                 <div style={{ minWidth: "100%", display: "flex", flexDirection: isMobile ? "column" : "row", gap: "20px", padding: "20px 0" }}>
//                   <div
//                     style={{
//                       flex: isMobile ? "1" : "0 0 40%",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       padding: isMobile ? "0 10px" : "0"
//                     }}
//                   >
//                     <img
//                       src={slides[activeSlide].image}
//                       style={{
//                         width: "100%",
//                         maxWidth: isMobile ? "100%" : "400px",
//                         height: "auto",
//                         borderRadius: "8px",
//                         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                         objectFit: "cover"
//                       }}
//                       alt="Slide"
//                     />
//                   </div>
//                   <div style={{ flex: isMobile ? "1" : "0 0 60%", padding: isMobile ? "10px" : "20px" }}>
//                     <h3 style={{ fontSize: isMobile ? "22px" : "28px", color: "#c53030", marginBottom: "20px" }}>
//                       {slides[activeSlide].title}
//                     </h3>
//                     {slides[activeSlide].content.map((section, idx) => (
//                       <div key={idx} style={{ marginBottom: "20px" }}>
//                         <h4
//                           style={{
//                             marginTop: "10px",
//                             marginLeft: isMobile ? "10px" : "20px",
//                             lineHeight: 1.5,
//                             fontSize: isMobile ? "18px" : "20px",
//                             color: "#2d3748",
//                             fontWeight: "600"
//                           }}
//                         >
//                           {section.heading}
//                         </h4>
//                         <ul style={{ marginLeft: isMobile ? "20px" : "30px", lineHeight: 1.8 }}>
//                           {section.items.map((item, i) => (
//                             <li key={i} style={{ fontSize: isMobile ? "14px" : "16px", color: "#4a5568" }}>
//                               {item}
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Navigation Buttons */}
//             <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
//               <button
//                 onClick={prevSlide}
//                 style={{
//                   padding: "10px 15px",
//                   background: "#fff",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center"
//                 }}
//                 aria-label="Previous slide"
//               >
//                 <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
//                   <path
//                     d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
//                     stroke="#030917"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//               <button
//                 onClick={nextSlide}
//                 style={{
//                   padding: "10px 15px",
//                   background: "#fff",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center"
//                 }}
//                 aria-label="Next slide"
//               >
//                 <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
//                   <path
//                     d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
//                     stroke="#030917"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//             </div>

//             {/* Slide Indicators */}
//             <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "15px" }}>
//               {slides.map((_, idx) => (
//                 <div
//                   key={idx}
//                   onClick={() => setActiveSlide(idx)}
//                   style={{
//                     width: "12px",
//                     height: "12px",
//                     borderRadius: "50%",
//                     background: activeSlide === idx ? "#c53030" : "#ccc",
//                     cursor: "pointer",
//                     transition: "background 0.3s"
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Proven Capability Section */}
//       <section style={{ background: "linear-gradient(to bottom right, #fff5f5, #fff0ea)", padding: "40px 20px", marginTop: "40px" }}>
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           <h2 style={{ fontSize: "36px", color: "#c53030", textAlign: "center", marginBottom: "30px" }}>
//             Proven Capability Through Global Expertise
//           </h2>
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
//             {[
//               {
//                 title: "Industry-Seasoned Core Team",
//                 points: [
//                   "Semiconductor professionals with decades of hands-on experience",
//                   "Track record in executing refurb, retrofit, and installation",
//                   "Expertise in critical wafer processing tools"
//                 ]
//               },
//               {
//                 title: "Elite Global Partner Network",
//                 points: [
//                   "Accomplished specialists in equipment refurbishment",
//                   "Executed projects in leading Fabs like TSMC, UMC",
//                   "Diverse regional strengths to optimize sourcing"
//                 ]
//               },
//               {
//                 title: "Outcome-Driven Delivery",
//                 points: [
//                   "SOPs, Process maps, Real-time project dashboards",
//                   "Transparent execution w.r.t. milestones",
//                   "Rigorous multi-point inspection and certification framework"
//                 ]
//               },
//               {
//                 title: "Scalable, Agile Supply Chain",
//                 points: [
//                   "Modular network adapts rapidly to dynamic timelines",
//                   "Flexible procurement and technical scope changes",
//                   "Risk mitigation through redundancy"
//                 ]
//               },
//               {
//                 title: "Risk Mitigation Through Redundancy",
//                 points: [
//                   "Multiple vetted partners mean robust fallback options",
//                   "Avoids single-point failures",
//                   "Ensures uninterrupted delivery"
//                 ]
//               },
//               {
//                 title: "Value Beyond Equipment",
//                 points: [
//                   "Turnkey support and Documentation",
//                   "Tools AMC, PM support",
//                   "Training to Fab personnel and Trained Manpower support"
//                 ]
//               }
//             ].map((card, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: "white",
//                   padding: "25px",
//                   borderRadius: "8px",
//                   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
//                 }}
//               >
//                 <h3 style={{ fontSize: "22px", color: "#c53030", marginBottom: "15px", fontWeight: "bold" }}>
//                   {card.title}
//                 </h3>
//                 <ul style={{ listStyle: "none", padding: 0 }}>
//                   {card.points.map((point, i) => (
//                     <li
//                       key={i}
//                       style={{
//                         fontSize: "16px",
//                         color: "#4a5568",
//                         marginBottom: "10px",
//                         paddingLeft: "20px",
//                         position: "relative",
//                         lineHeight: 1.6
//                       }}
//                     >
//                       <span
//                         style={{
//                           position: "absolute",
//                           left: 0,
//                           color: "#c53030",
//                           fontWeight: "bold"
//                         }}
//                       >
//                         •
//                       </span>
//                       {point}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Module Support Section */}
//       <section style={{ padding: "40px 20px", maxWidth: "1200px", margin: "0 auto" }}>
//         <h2 style={{ fontSize: "36px", color: "#c53030", textAlign: "center", marginBottom: "30px" }}>
//           Module Support Through Trusted Global Partners
//         </h2>
//         <div style={{ textAlign: "center", fontSize: "18px", marginBottom: "30px", color: "#4a5568" }}>
//           <p>Partners are primarily based in <strong>Taiwan, Singapore, Korea</strong></p>
//           <p style={{ marginTop: "10px" }}>
//             Several decades of experience with proven expertise at <strong>TSMC, UMC, GF</strong>
//           </p>
//           <p style={{ marginTop: "10px" }}>Equipment Retrofits, Relocation, Hookups, Maintenance</p>
//         </div>

//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: "20px",
//             marginTop: "30px"
//           }}
//         >
//           {[
//             { name: "DIFFUSION", desc: "Deep capability across thermal based systems" },
//             { name: "RTP", desc: "Rapid Thermal Processing" },
//             { name: "ETCH", desc: "Plasma-based systems" },
//             { name: "IMPLANT", desc: "Advanced control and integration" },
//             { name: "CD-SEM", desc: "Critical Dimension metrology & inspection" },
//             { name: "KLA TOOLS", desc: "Advanced inspection systems" },
//             { name: "PVD", desc: "Scalable solutions for metal and dielectric deposition" },
//             { name: "CVD", desc: "Chemical Vapor Deposition systems" }
//           ].map((module, idx) => (
//             <div
//               key={idx}
//               style={{
//                 background: "linear-gradient(135deg, #c53030, #e87722)",
//                 color: "white",
//                 padding: "30px 20px",
//                 borderRadius: "8px",
//                 textAlign: "center",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 transition: "transform 0.3s",
//                 cursor: "pointer"
//               }}
//               onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
//               onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
//             >
//               <h3 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "10px" }}>
//                 {module.name}
//               </h3>
//               <p style={{ fontSize: "14px", opacity: 0.9 }}>{module.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Thank You Section */}
//       {/* <section
//         style={{
//           background: "linear-gradient(to right, #c53030, #e87722)",
//           color: "white",
//           padding: "60px 20px",
//           textAlign: "center"
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           <h2 style={{ fontSize: "42px", marginBottom: "20px", fontWeight: "bold" }}>
//             Let us work together to do our part for the India Semiconductor success story
//           </h2>
//           <p style={{ fontSize: "28px", marginTop: "30px", fontWeight: "600" }}>
//             Our Time is NOW!
//           </p>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
//               gap: "15px",
//               marginTop: "40px",
//               fontSize: "18px"
//             }}
//           >
//             {[
//               "Thank You",
//               "ধন্যবাদ",
//               "આભાર",
//               "धन्यवाद",
//               "ಧನ್ಯವಾದಗಳು",
//               "നന്ദി",
//               "ଧନ୍ୟବାଦ",
//               "ਧੰਨਵਾਦ",
//               "நன்றி",
//               "ధన్యవాదాలు",
//               "Dank Schön",
//               "Merci",
//               "Gracias"
//             ].map((text, idx) => (
//               <div key={idx} style={{ padding: "10px", opacity: 0.9 }}>
//                 {text}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section> */}

//       {/* Footer Note */}
//       {/* <div
//         style={{
//           textAlign: "center",
//           padding: "20px",
//           fontSize: "14px",
//           color: "#666",
//           background: "#f9f9f9"
//         }}
//       >
//         <p>
//           <strong>Note:</strong> Possible scaling with faster onboarding upon confirmation
//         </p>
//       </div> */}
//     </div>
//   );
// };

// export default EquipmentRefurbishment;




import React, { useState } from "react";

const EquipmentRefurbishment = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slides = [
    {
      title: "Module Expertise – Equipment & Technology",
      image: "./assets/img/bg/mans.png",
      content: [
        {
          heading: "Diffusion / WET",
          items: [
            "Wet benches: DNS, Kaijo, SES",
            "Backside cleaning: SEZ, Nexgen"
          ]
        },
        {
          heading: "Chemical Mechanical Planarization",
          items: ["DNS", "AMAT"]
        },
        {
          heading: "Lithography",
          items: ["ASML, Nikon, TEL, Suss"]
        },
        {
          heading: "Thin Film Deposition - CVD & PEALD",
          items: ["AMAT, ASM, Novellus (LAM), Telemark"]
        }
      ]
    },
    {
      title: "Module Expertise – Equipment & Technology (Continued)",
      image: "./assets/img/bg/hc.jpg",
      content: [
        {
          heading: "Ion Implant",
          items: ["Axcelis"]
        },
        {
          heading: "Etch",
          items: ["Mattson, LAM"]
        },
        {
          heading: "Sort and Merge",
          items: ["Brooks"]
        },
        {
          heading: "Metrology, Inspection",
          items: [
            "KLA",
            "Hitachi",
            "Zeiss",
            "Quantox",
            "Semilab"
          ]
        },
        {
          heading: "Other Services",
          items: ["Cleanroom design, construction certification"]
        }
      ]
    },
    {
      title: "Strategic Enhancements",
      image: "./assets/img/bg/mans.png",
      content: [
        {
          heading: "Core Capabilities",
          items: [
            "200+ years of collective experience to support Upgrade, Replacement / Refurbishment and new OEM tools",
            "Strong Supplier Management and Program Governance",
            "Refurbished equipment integration for cost-efficiency and improved uptime",
            "Real-time monitoring systems deployed across modules",
            "Introduction of alternative sources: Chemicals, Slurries, New lines"
          ]
        },
        {
          heading: "Cross-functional projects",
          items: [
            "Quality",
            "Cost",
            "Productivity"
          ]
        }
      ]
    }
  ];

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {/* Hero Section */}
 {/* <section style={{ position: "relative", height: "500px", overflow: "hidden" }}>
        <img
          src="assets/img/service/mw7.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0
          }}
          alt="Hero Background"
        />
        <div
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0, 0, 0, 0.5)",
            color: "white",
            textAlign: "center",
            padding: "20px"
          }}
        >
          <div>
            <p style={{ fontSize: "18px", letterSpacing: "3px", marginBottom: "10px" }}>
              Equipment Refurbishment
            </p>
            <p
              style={{
                backgroundColor: "rgb(232, 119, 34)",
                color: "white",
                padding: "8px 15px",
                fontWeight: "bold",
                display: "inline-block",
                borderRadius: "5px",
                marginBottom: "20px"
              }}
            >
              SEMANTIC Skills Junction
            </p>
            <h1 style={{ fontSize: "45px", margin: "20px 0", lineHeight: 1.2 }}>
              Equipment Support & Technology Excellence
            </h1>
            <p style={{ fontSize: "16px", marginTop: "15px" }}>
              <a href="/" style={{ color: "white", textDecoration: "none" }}>Home</a> / Equipment Refurbishment
            </p>
          </div>
          <a
            href="tel:+917619617023"
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              color: "white",
              textDecoration: "none",
              fontSize: "18px",
              fontWeight: "bold"
            }}
          >
            (+91) 7619617023
          </a>
        </div>
      </section> */}

<section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>
      {/* Scope Section */}
      <div style={{ padding: "2rem", maxWidth: "1200px", margin: "20px auto" }}>
        <div
          style={{
            background: "linear-gradient(to bottom right, #fff5f5, #fff0ea)",
            borderRadius: "8px",
            padding: "2rem",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
          }}
        >
          <h2
            style={{
              color: "#c53030",
              fontSize: "38px",
              fontWeight: "bold",
              marginBottom: "1.5rem"
            }}
          >
            Scope of Industry Consultancy Services
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Full spectrum support across all Process Modules
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Retrofit and qualification of legacy and refurbished equipment
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Real-time monitoring infrastructure for process control and diagnostics
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Ongoing improvements in Preventive Maintenance [PM] strategies
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Annual Maintenance Contracts [AMC]
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Robust program governance with rigorous supplier management protocols
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Process Centering and setup
                </span>
              </p>
            </div>
            <div>
              <p style={{ marginBottom: "10px" }}>
                <span style={{ color: "rgb(179, 0, 0)", fontWeight: "bold", fontSize: "20px" }}>➤</span>{" "}
                <span style={{ color: "black", fontSize: "18px", fontWeight: 500 }}>
                  Quality Management System [QMS] Setup, Implementation, Certification, Maintenance
                </span>
              </p>
            </div>
            <div style={{ marginTop: "20px", padding: "15px", background: "white", borderRadius: "5px" }}>
              <p style={{ fontSize: "20px", fontWeight: 600, color: "#c53030", marginBottom: "10px" }}>
                Service Types:
              </p>
              <p style={{ fontSize: "18px", color: "black" }}>
                Installation • Upgrades • Refurbishment • Repairs • Qualifications • Maintenance
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content with Description */}
      <section style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
        <div style={{ marginTop: "15px", fontSize: "20px", lineHeight: 1.6, color: "#333" }}>
          <strong>200+ years of collective experience</strong> to support Upgrade, Replacement / Refurbishment and new OEM tools. 
          <strong> Strong Supplier Management and Program Governance.</strong> Refurbished equipment integration for cost-efficiency and improved uptime. 
          Real-time monitoring systems deployed across modules. Introduction of alternative sources: Chemicals, Slurries, New lines. 
          Cross-functional projects: <strong>Quality, Cost, Productivity</strong>.
        </div>

        {/* Slider Section */}
        <div style={{ marginTop: "40px" }}>
          <div style={{ position: "relative" }}>
            <div style={{ overflow: "hidden" }}>
              <div style={{ display: "flex", transition: "transform 0.3s ease" }}>
                <div style={{ minWidth: "100%", display: "flex", flexDirection: isMobile ? "column" : "row", gap: "20px", padding: "20px 0" }}>
                  <div
                    style={{
                      flex: isMobile ? "1" : "0 0 40%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: isMobile ? "0 10px" : "0"
                    }}
                  >
                    <img
                      src={slides[activeSlide].image}
                      style={{
                        width: "100%",
                        maxWidth: isMobile ? "100%" : "400px",
                        height: "auto",
                        borderRadius: "8px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        objectFit: "cover"
                      }}
                      alt="Slide"
                    />
                  </div>
                  <div style={{ flex: isMobile ? "1" : "0 0 60%", padding: isMobile ? "10px" : "20px" }}>
                    <h3 style={{ fontSize: isMobile ? "22px" : "28px", color: "#c53030", marginBottom: "20px" }}>
                      {slides[activeSlide].title}
                    </h3>
                    {slides[activeSlide].content.map((section, idx) => (
                      <div key={idx} style={{ marginBottom: "20px" }}>
                        <h4
                          style={{
                            marginTop: "10px",
                            marginLeft: isMobile ? "10px" : "20px",
                            lineHeight: 1.5,
                            fontSize: isMobile ? "18px" : "20px",
                            color: "#2d3748",
                            fontWeight: "600"
                          }}
                        >
                          {section.heading}
                        </h4>
                        <ul style={{ marginLeft: isMobile ? "20px" : "30px", lineHeight: 1.8 }}>
                          {section.items.map((item, i) => (
                            <li key={i} style={{ fontSize: isMobile ? "14px" : "16px", color: "#4a5568" }}>
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
              <button
                onClick={prevSlide}
                style={{
                  padding: "10px 15px",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center"
                }}
                aria-label="Previous slide"
              >
                <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
                  <path
                    d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                    stroke="#030917"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button
                onClick={nextSlide}
                style={{
                  padding: "10px 15px",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center"
                }}
                aria-label="Next slide"
              >
                <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
                  <path
                    d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                    stroke="#030917"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Slide Indicators */}
            <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "15px" }}>
              {slides.map((_, idx) => (
                <div
                  key={idx}
                  onClick={() => setActiveSlide(idx)}
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    background: activeSlide === idx ? "#c53030" : "#ccc",
                    cursor: "pointer",
                    transition: "background 0.3s"
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Proven Capability Section */}
      <section style={{ background: "linear-gradient(to bottom right, #fff5f5, #fff0ea)", padding: "40px 20px", marginTop: "40px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "36px", color: "#c53030", textAlign: "center", marginBottom: "30px" }}>
            Proven Capability Through Global Expertise
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
            {[
              {
                title: "Industry-Seasoned Core Team",
                points: [
                  "Semiconductor professionals with decades of hands-on experience in Fab equipment and process.",
                  "Track record in executing refurb, retrofit, and installation for critical wafer processing tools."
                ]
              },
              {
                title: "Elite Global Partner Network",
                points: [
                  "Accomplished specialists in equipment refurbishment",
                  "Executed projects in leading Fabs like TSMC, UMC.",
                  "Diverse regional strengths to reduce lead times, optimize sourcing."
                ]
              },
              {
                title: "Outcome-Driven Delivery",
                points: [
                  "SOPs, Process maps, Real-time project dashboards for transparent execution w.r.t. milestones.",
                  "Quality mindset: Every tool delivered passes through a rigorous multi-point inspection and certification framework."
                ]
              },
              {
                title: "Scalable, Agile Supply Chain",
                points: [
                  "Modular network adapts rapidly to dynamic Timelines, Procurement and Technical scope changes."
                ]
              },
              {
                title: "Risk Mitigation Through Redundancy",
                points: [
                  "Multiple vetted partners mean robust fallback options.",
                  "Avoids single-point failures and ensures uninterrupted delivery."
                ]
              },
              {
                title: "Value Beyond Equipment",
                points: [
                  "Turnkey support",
                  "Documentation",
                  "Tools AMC, PM support",
                  "Training to Fab personnel",
                  "Trained Manpower support."
                ]
              }
            ].map((card, idx) => (
              <div
                key={idx}
                style={{
                  background: "white",
                  padding: "25px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
                }}
              >
                <h3 style={{ fontSize: "22px", color: "#c53030", marginBottom: "15px", fontWeight: "bold" }}>
                  {card.title}
                </h3>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {card.points.map((point, i) => (
                    <li
                      key={i}
                      style={{
                        fontSize: "16px",
                        color: "#4a5568",
                        marginBottom: "10px",
                        paddingLeft: "20px",
                        position: "relative",
                        lineHeight: 1.6
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          left: 0,
                          color: "#c53030",
                          fontWeight: "bold"
                        }}
                      >
                        •
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Module Support Section */}
      <section style={{ padding: "40px 20px", maxWidth: "1200px", margin: "0 auto" }}>
        <h2 style={{ fontSize: "36px", color: "#c53030", textAlign: "center", marginBottom: "30px" }}>
          Module Support Through Trusted Global Partners
        </h2>
        <div style={{ textAlign: "center", fontSize: "18px", marginBottom: "30px", color: "#4a5568" }}>
          <p>Partners are primarily based in <strong>Taiwan, Singapore</strong></p>
          <p style={{ marginTop: "10px" }}>
            Several decades of experience; proven expertise at <strong>TSMC, UMC, GF</strong> – Equipment Retrofits, Relocation, Hookups, Maintenance
          </p>
          <p style={{ marginTop: "10px" }}>Wafer Fab experienced manpower support.</p>
          <p style={{ marginTop: "15px", fontSize: "14px", fontStyle: "italic" }}>* Primarily Singapore, Taiwan, Korea based</p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",

            gap: "20px",
            marginTop: "30px"
          }}
        >
          {[
            { name: "Diffusion, RTP", desc: "Deep capability across thermal based systems" },
         
            { name: "Etch", desc: "Plasma-based systems" },
            { name: "Implant", desc: "Advanced control and integration" },
            { name: "CD-SEM, KLA Tools", desc: "Critical Dimension metrology & inspection" },
           
            { name: "PVD", desc: "Scalable solutions for metal and dielectric deposition" },
            { name: "CVD", desc: "Scalable solutions for dielectric deposition" }
          ].map((module, idx) => (
            <div
              key={idx}
              style={{
                background: "linear-gradient(135deg, #c53030, #e87722)",
                color: "white",
                padding: "30px 20px",
                borderRadius: "8px",
                textAlign: "center",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.3s",
                cursor: "pointer",
                minHeight: "120px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <h3 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: module.desc ? "10px" : "0" }}>
                {module.name}
              </h3>
              {module.desc && <p style={{ fontSize: "14px", opacity: 0.9 }}>{module.desc}</p>}
            </div>
          ))}
        </div>
      </section>
{/* Diagram Section - Add this right after Module Support section ends */}
<section style={{ padding: "60px 20px", background: "#f8f9fa", marginTop: "40px" }}>
  <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
    <h2 style={{ fontSize: "36px", color: "#c53030", marginBottom: "40px" }}>
      Our Comprehensive Service Network
    </h2>
    <div style={{ 
      background: "white", 
      padding: "40px", 
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      display: "inline-block",
      maxWidth: "800px"
    }}>
      <img 
        src="/Skills.jpeg" 
        alt="SEMANTIC Skills Junction Network Diagram"
        style={{
          width: "100%",
          height: "auto",
          maxWidth: "700px"
        }}
      />
    </div>
    <p style={{ 
      marginTop: "30px", 
      fontSize: "18px", 
      color: "#4a5568",
      fontStyle: "italic"
    }}>
      {/* Connecting expertise across all semiconductor manufacturing processes */}
    </p>
  </div>
</section>
      {/* Thank You Section */}
      {/* <section
        style={{
          background: "linear-gradient(to right, #c53030, #e87722)",
          color: "white",
          padding: "60px 20px",
          textAlign: "center"
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "42px", marginBottom: "20px", fontWeight: "bold" }}>
            Let us work together to do our part for the India Semiconductor success story.
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
              gap: "15px",
              marginTop: "40px",
              fontSize: "20px"
            }}
          >
            {[
              "ধন্যবাদ",
              "তোমাকে ধন্যবাদ",
              "આભાર",
              "धन्यवाद",
              "ಧನ್ಯವಾದಗಳು",
              "दिनवास",
              "നന്ദി",
              "ଧନ୍ୟବାଦ",
              "ਤੁਹਾਡਾ ਧੰਨਵਾਦ",
              "अनुगृहितोऽस्मि",
              "நன்றி",
              "ధన్యవాదాలు",
              "Thank You",
              "Dank Schön",
              "Merci",
              "Gracias"
            ].map((text, idx) => (
              <div key={idx} style={{ padding: "10px", opacity: 0.95 }}>
                {text}
              </div>
            ))}
          </div>
          <p style={{ fontSize: "32px", marginTop: "40px", fontWeight: "700" }}>
            Our Time is NOW!
          </p>
        </div>
      </section> */}

      {/* Footer Note */}
      {/* <div
        style={{
          textAlign: "center",
          padding: "25px",
          fontSize: "16px",
          color: "#666",
          background: "#f9f9f9",
          fontStyle: "italic"
        }}
      >
        <p>
          &gt;&gt; Possible scaling with faster onboarding upon confirmation
        </p>
      </div> */}
    </div>
  );
};

export default EquipmentRefurbishment;